export const EVENT_NAMES = {
  TEST: 'test',

  //项目加载
  PROJECT_LOAD: 'PROJECT_LOAD',
  //编辑器预览加载
  PROJECT_PREVIEW_LOAD: 'PROJECT_PREVIEW_LOAD',

  //书页操作
  BOOK_PAGE_ADD: 'BOOK_PAGE_ADD',
  BOOK_PAGE_REMOVE: 'BOOK_PAGE_REMOVE',
  BOOK_PAGE_THUMB_SYNC: 'BOOK_PAGE_THUMB_SYNC',
  BOOK_COVER_SYNC: 'UPLOAD_BOOK_COVER',
  /** 阅读器书本显示尺寸就绪（相对阅读容器坐标系） */
  BOOK_DISPLAY_SIZE_READY: 'BOOK_DISPLAY_SIZE_READY',

  //元素操作
  ACTION_RELOAD: 'ACTION_RELOAD',
  ACTION_ADD: 'ACTION_ADD',
  ELEMENT_UPDATE: 'ELEMENT_UPDATE',
  APPLY_ALL_TEXTSTYLE: 'APPLY_ALL_TEXTSTYLE',
  BGM_ADD: 'BGM_ADD',

  //导出
  EXPORT_PDF: 'EXPORT_PDF',
  EXPORT_JPG: 'EXPORT_JPG',

  //水印弹窗
  WATERMARK_DIALOG_OPEN: 'WATERMARK_DIALOG_OPEN',

  //阅读器重播
  BOOK_REPLAY: 'BOOK_REPLAY'
} as const;

export type EventName = (typeof EVENT_NAMES)[keyof typeof EVENT_NAMES];

export default EVENT_NAMES;
